<template>
	<dms-wrapper :label="labelText" :show-label="!isHiddenLabel" v-bind="{wrapp, validationRules, span, ...$attrs}" :validation-property="validationPropertyCmp"
		:disabled="isDisabled">
		<el-time-select :disabled="isDisabled" :value="value" :placeholder="placeholderText" @input="inputEvent($event)" @keyup="$emit('keyup', $event)" />
	</dms-wrapper>
</template>

<script>
import { BaseInput } from '#components/dms/common/baseInput';
import DmsWrapper from '#components/dms/form/Wrapper.vue';

export default BaseInput.extend({
	name: 'DmsTimePicker',
	components: { DmsWrapper },
	methods: {
		inputEvent(event) {
			this.$emit('update:value', event);
		},
	},
});
</script>
